const _version = "2.15.6"
function version() {
    return _version
}
export default version
